import { ColGroupDef } from 'ag-grid-community'
import { intl } from '../../../../../../i18n'
import { ProgramManagementRow } from '../../../programManagement'
import { calculateProductivity } from './aggregation'
import {
  RowValueGetter,
  numericCellStyle,
  hoursValueFormatter,
  percentValueFormatter,
} from './common'

// --- Productivity group ---

export const productivityColumns: ColGroupDef<ProgramManagementRow> = {
  headerName: intl.formatMessage({
    id: 'programManagement.column.productivity',
  }),
  children: [
    {
      colId: 'productivity.sv',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.sv',
      }),
      width: 80,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'sv'),
      cellStyle: numericCellStyle,
      valueFormatter: hoursValueFormatter,
    },
    {
      colId: 'productivity.spi',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.spi',
      }),
      width: 70,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'spi'),
      cellStyle: numericCellStyle,
      valueFormatter: percentValueFormatter,
    },
    {
      colId: 'productivity.cv',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.cv',
      }),
      width: 80,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'cv'),
      cellStyle: numericCellStyle,
      valueFormatter: hoursValueFormatter,
    },
    {
      colId: 'productivity.cpi',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.cpi',
      }),
      width: 70,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'cpi'),
      cellStyle: numericCellStyle,
      valueFormatter: percentValueFormatter,
    },
    {
      colId: 'productivity.etc',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.etc',
      }),
      width: 80,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'etc'),
      cellStyle: numericCellStyle,
      valueFormatter: hoursValueFormatter,
    },
    {
      colId: 'productivity.eac',
      headerName: intl.formatMessage({
        id: 'programManagement.column.productivity.eac',
      }),
      width: 80,
      editable: false,
      valueGetter: (params: RowValueGetter) =>
        calculateProductivity(params, 'eac'),
      cellStyle: numericCellStyle,
      valueFormatter: hoursValueFormatter,
    },
  ],
}
